import { checkUrlRegistEmail } from '@/features/homepage/api/ApiCheckUrlRegistEmail';
import storage from '@/utils/storage';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';


const ConfirmTokenPage = () => {
    const [loading, setLoading] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();
    const [urlValidateResult, setUrlValidateResult] = useState(false);
    useEffect(() => {
        storage.clearAll();
        const validateToken = async () => {
            setLoading(true);
            try {
                const data_request = {
                    url_token: token,
                };
                const res = await checkUrlRegistEmail(data_request);
                if (res && res.status == "expire") {
                    setUrlValidateResult(false);
                    navigate('/token-expired', { state: { company_info: res.company_info ?? null } });
                } else {
                    setUrlValidateResult(true);
                    navigate(`/login/${token}`)
                }
            } catch (error) {
                setSystemError(ERR_MESSAGE.WAS001_MESSAGE);
                setUrlValidateResult(false);
            } finally {
                setLoading(false);
            }
        };

        validateToken();
    }, [token, navigate]);


    return (
        <>
        </>
    );
};

export default ConfirmTokenPage;
